import { Typography } from 'antd';
import styled from 'styled-components';
import { Caption01 } from 'components/styles';

export const GroupTitle = styled(Typography.Text)`
  ${Caption01};
  color: var(--gray-80);
  width: 100px;
`;
